import React, { useEffect, useState } from "react";
import Pdf from "../../../../../../Components/Icons/Pdf";
import NewReportTable from "../../../../../../Components/Others/NewReportTable";
import {
  CancelButton,
  SubmitButton,
} from "../../../../../../Components/Utils/Buttons";
import { useFormik } from "formik";
import UseFetchReportData from "../../../../../../Components/Hooks/useFetchReportData";
import axiosInstance from "../../../../../../Services/axiosCommon";
import { FormikSelectTwoSmall } from "../../../../../../Components/Utils/Select";
import { NuDateSmall } from "../../../../../../Components/Utils/Input";
import UseDropDown from "../../../../../../Components/Hooks/useDropDown";
import NuDateFormat from "../../../../../../Components/Utils/NuDate";
import Xls from "../../../../../../Components/Icons/Xls";
import useFetchMDIndex from "../../../../../../Components/Hooks/useFetchMDIndex";
import Pagination from "../../../../../../Components/Utils/Pagenation";

function YPRReport() {
  const [showFilter, setShowFilter] = useState(false);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(
    localStorage.getItem("perPageView") || 20,
  );
  const { data: RFQAssignee } = UseDropDown("/user/procurement/drop-down");
  const { data: Salesman } = UseDropDown("/user/salesman/drop-down");

  const { value: status } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "rfqStatus_pr",
    true,
  );
  // const { value: Category } = useFetchMDIndex(
  //   `/dropdown/dropdown-details/`,
  //   "category_Customer",
  //   true,
  // );

  // const [filter, setFilter] = useState(false);
  const headers = [
    {
      title: "YPR",
      width: "15%",
      field: "ypr",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "RFQ Assignee",
      width: "15%",
      field: "rfqAssignee",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Assign. Date",
      width: "15%",
      field: "assignDate",
      type: "date",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "DeadLine",
      width: "15%",
      field: "deadLine",
      type: "date",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Days Elapsed",
      width: "10%",
      field: "daysElapsed",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Salesman",
      width: "15%",
      field: "salesman",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Status",
      width: "15%",
      field: "status",
      textAlign: "left",
      rowAlign: "left",
    },
  ];

  const [filterProps, setFilterProps] = useState({
    rfqAssignee: "",
    salesPerson: "",
    dateFrom: "",
    dateTo: "",
    // category: "",
    status: "",
    // approvalStatus: "",
  });

  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    rfqAssignee: "",
    salesPerson: "",
    dateFrom: "",
    dateTo: "",
    // category: "",
    status: "",
    // approvalStatus: "",
  });

  useEffect(() => {
    setParams({ ...params, page: page, per_page: pageCount });
  }, [page, pageCount]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value) => {
      setParams({
        ...params,
        page: 1,
        rfqAssignee: value.rfqAssignee,
        salesPerson: value.salesPerson,
        dateFrom: value.dateFrom,
        dateTo: value.dateTo,
        // category: value.category,
        status: value.status,
        // approvalStatus: value.approvalStatus,
      });
      setPage(1);
    },
  });
  const { data, getData, dataLoading, total, other } = UseFetchReportData(
    "/report/pr",
    params,
  );

  function clearFilters() {
    setShowFilter(false);
    formik.resetForm();
    // setFilter(false);
    setPage(1);
    setParams({
      page: 1,
      per_page: pageCount,
      rfqAssignee: "",
      salesPerson: "",
      dateFrom: "",
      dateTo: "",
      // category: "",
      status: "",
      // approvalStatus: "",
    });
  }

  const downloadPDF = async () => {
    try {
      const response = await axiosInstance.get(
        `/report/pr/pdf`,
        {
          params,
          responseType: "blob",
        },
      );
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(pdfBlob);
      link.download = `YPR Report ${NuDateFormat({ value: new Date(), format: "DD-MM-YYYY" })}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  };

  const downloadxlsx = async () => {
    try {
      const response = await axiosInstance.get(`/report/pr/xlsx`, {
        params,
        responseType: "blob",
      });
      const xlsxBlob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(xlsxBlob);
      link.download = `YPR Report ${NuDateFormat({ value: new Date(), format: "DD-MM-YYYY" })}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the xlsx:", error);
    }
  };

  return (
    <>
      <div className="w-full h-[calc(100vh-140px)] flex flex-col">
        <div className="w-full items-center gap-x-3 bg-white flex-shrink-0">
          <div className="flex justify-between items-center w-full">
            <p className=" font-semibold text-xs 2xl:text-sm pt-1">
              YPR : {total || 0}
            </p>

            <div className=" flex gap-4 justify-end mt-1">
              <button onClick={downloadPDF}>
                <Pdf />
              </button>
              <button onClick={downloadxlsx}>
                <Xls />
              </button>
            </div>
          </div>

          <form onSubmit={formik.handleSubmit}>
            <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-2 sm:gap-x-3">
              <NuDateSmall
                label="DeadLine From"
                placeholder="dd/mm/yyyy"
                formik={formik}
                name="dateFrom"
                width="w-full"
              />
              <NuDateSmall
                label="DeadLine To"
                placeholder="dd/mm/yyyy"
                formik={formik}
                name="dateTo"
                width="w-full"
              />
              <FormikSelectTwoSmall
                type="text"
                label="RFQ Assignee"
                placeholder="Choose"
                Options={RFQAssignee}
                formik={formik}
                name="rfqAssignee"
                width="w-full"
                FixPosition={true}
                PortalTarget={false}
                isClear={true}
              />
              <FormikSelectTwoSmall
                type="text"
                label="Sales Person"
                placeholder="Choose"
                Options={Salesman}
                formik={formik}
                name="salesPerson"
                width="w-full"
                FixPosition={true}
                PortalTarget={false}
                isClear={true}
              />
              <FormikSelectTwoSmall
                type="text"
                label="Status"
                placeholder="Choose"
                Options={status}
                formik={formik}
                name="status"
                width="w-full"
                FixPosition={true}
                PortalTarget={false}
                isClear={true}
              />
              <div className="w-full flex justify-end mb-1.5 sm:col-start-4">
                <div className="w-full flex justify-end items-end gap-2">
                  <SubmitButton name="Apply" />
                  <CancelButton label="Clear" handleClick={clearFilters} />
                </div>
              </div>
            </div>
          </form>
        </div>

        <div className="w-full flex-grow overflow-y-auto">
          <NewReportTable
            headers={headers}
            data={data}
            dataLoading={dataLoading}
          />
        </div>
        <div className=" w-full h-[40px] text-[#4f4768] flex-shrink-0 bg-white border-t">
          <Pagination
            total={total}
            pageIndex={page}
            setPageIndex={setPage}
            dataCount={pageCount}
            setDataCount={setPageCount}
          />
        </div>
      </div>
    </>
  );
}

export default YPRReport;
